module.exports = __webpack_public_path__ + "tables/media/Profile_outlined.e3aaf1c7.svg";